import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import DetailedStatistics from '../../components/Stats/DetailedStatistics';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['viberMessage']}`;

const ViberMessagesStatisticsPage = () => {
  const fetch = useFetch();

  const [viberMessage, setViberMessage] = useState();
  const [error, setError] = useState();
  const { accountId, domainId, viberMessageId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/viberMessages/${viberMessageId}`)
      .then(({ viberMessage }) => setViberMessage(viberMessage))
      .catch(setError);
  }, [accountId, domainId, viberMessageId, fetch]);

  return (
    <>
      <Metadata title={`${page} | ${viberMessage?.name || 'Unnamed text message'}`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/viber`}>{page}</Anchor>
        <Text>{viberMessage?.name || 'Unnamed text message'}</Text>
      </Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          {error ? (
            <ErrorMessage message={error.message} />
          ) : (
            <DetailedStatistics name={viberMessage?.name} scope="viberMessages" id={viberMessageId} />
          )}
        </Grid.Col>
      </Grid>
    </>
  );
};

export default ViberMessagesStatisticsPage;
